import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import SeoCms from '~/src/common/components/Seo/SeoCms';
import { PageContent, getPageModelEntry } from '~/src/common/services/Builder';
import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import CatalogLayout from '~/src/screens/App/CatalogLayout';
import { NextPage } from '~/src/typings/next';

const PAGE_MODEL = 'brand';

const BrandPage: NextPage = () => {
  const path = useRouter().asPath;
  const { data } = useQuery(...getPageModelEntry(PAGE_MODEL, path));

  return (
    <>
      <SeoCms data={data?.data} />
      <PageContent model={PAGE_MODEL} content={data} />
    </>
  );
};

BrandPage.Layout = ({ children, ...props }: AnyObject) => (
  <CatalogLayout {...props} areProductsDisplayed={false}>
    {children}
  </CatalogLayout>
);

export const getServerSideProps = withEnhancedGSSP(
  async ({ resolvedUrl, query }, { prefetch, notFound }) => {
    // Skip le prefetch si builder est en mode preview
    if ('builder.preview' in query) return;

    // Sinon, on prefetch normalement, et 404 si pas de résultats
    const res = await prefetch(...getPageModelEntry(PAGE_MODEL, resolvedUrl));
    if (res == null) notFound();
  },
);

export default BrandPage;
